"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.view = void 0;
var csod = require("player-core");
function view(props) {
    var _this = this;
    return {
        state: {
            showPrev: (this.props.currentPage > 1),
            showNext: (this.props.totalPages > this.props.currentPage),
            showSubmit: (this.props.currentPage == this.props.totalPages && this.props.totalPages > 0),
            isCancelBtnEnabled: !csod.viewModel.isPreview,
            isSaveBtnEnabled: !csod.viewModel.isPreview
        },
        initialize: function () {
            return new Promise(function (resolve) {
                resolve();
            });
        },
        mounted: function () {
        },
        receivedProps: function (nextProps) {
            return new Promise(function (resolve) {
                _this.view.state.showPrev = (nextProps.currentPage > 1);
                _this.view.state.showNext = (nextProps.totalPages > nextProps.currentPage);
                _this.view.state.showSubmit = (nextProps.currentPage == nextProps.totalPages && nextProps.totalPages > 0);
                resolve();
            });
        },
        unmount: function () {
        },
        events: {
            onBack: function () {
                props.onBack && props.onBack();
            },
            onNext: function () {
                props.onNext && props.onNext();
            },
            onSubmit: function () {
                props.onSubmit && props.onSubmit();
            },
            onCancel: function () {
                props.onCancel && props.onCancel();
            },
            onSave: function () {
                props.onSave && props.onSave();
            }
        }
    };
}
exports.view = view;



//////////////////
// WEBPACK FOOTER
// C:/TeamCity/buildAgent/work/2c51a2fe812ded8e/src/.tmp/ApplicationWorkflowIsolationBar/View.js
// module id = 588
// module chunks = 0